const accordionPanel = document.querySelector('.accordion_panel__accordion');
const simpleTabs = document.querySelector('.simple_tabs_panel__tabs');

document.addEventListener('DOMContentLoaded', event => {
  const urlWithAnchor = new URL(window.location.href);
  const hash = urlWithAnchor.hash.replace('#', '');
  const anchorElement = document.getElementById(hash);

  if (accordionPanel) {
    /**
     * Turn off automatic "scroll restoration" on refresh here so we don't get a scroll "bounce" back
     * to wherever the user had last scrolled to - even just the top of the page. In favor of the
     * Element.scrollIntoView() behavior.
     *
     * @type {string}
     */
    history.scrollRestoration = "manual";
    window.onunload = () => {
      window.scrollTo(0, 0);
    };

    if (anchorElement) {
      if (anchorElement.nextElementSibling && anchorElement.nextElementSibling.classList.contains('accordion__header')) {
        anchorElement.nextElementSibling.click();
        anchorElement.scrollIntoView({behavior: "smooth"});
      }
    }
  }

  if (simpleTabs) {
    if (anchorElement) {
      if (anchorElement.parentElement && anchorElement.parentElement.classList.contains('js-tabs__tabs-container')) {
        anchorElement.click();

        const anchorParentRect = anchorElement.parentElement.getBoundingClientRect();
        const expFactor = 0.98;
        if (anchorParentRect instanceof DOMRect) {
          console.log(anchorParentRect, 'anchorParent');
          window.scrollTo(0, ((anchorParentRect.y - anchorParentRect.height) * expFactor));
        }

      }
    }
  }
});

window.onhashchange = (context) => {
  const urlWithAnchor = new URL(context.newURL);
  const hash = urlWithAnchor.hash.replace('#', '');
  const anchorElement = document.getElementById(hash);

  if (accordionPanel) {
    if (anchorElement) {
      if (anchorElement.nextElementSibling && anchorElement.nextElementSibling.classList.contains('accordion__header')) {
        anchorElement.nextElementSibling.click();
      }
    }
  }

  if (simpleTabs) {
    if (anchorElement) {
      if (anchorElement.parentElement && anchorElement.parentElement.classList.contains('js-tabs__tabs-container')) {
        anchorElement.click();

        const anchorParentElem = anchorElement.parentElement;
        const anchorParentRect = anchorParentElem.getBoundingClientRect();
        const headerElem = document.querySelector('.header');

        const expFactor = 0.98;
        if (anchorParentRect instanceof DOMRect) {
          console.log(anchorParentRect, 'anchorParent');

          // let scrollAmount = ((anchorParentRect.y - anchorParentRect.height) * expFactor) + window.scrollY;
          let scrollAmount = ((anchorParentRect.y - anchorParentRect.height)) + window.scrollY;
          console.log(scrollAmount, 'scrollAmount');
          let scrollDest;
          if (headerElem.classList.contains('header--visible')) {
            scrollDest = (scrollAmount - headerElem.clientHeight) * expFactor;
          } else {
            scrollDest = scrollAmount * expFactor;
          }

          console.log(scrollDest, 'scrollDest');
          window.scrollTo(0, scrollDest);
          // window.scrollTo(0, ((anchorParentRect.y - anchorParentRect.height) * expFactor));
        }

      }
    }
  }

}
